<template>
  <div class="full-height tkRefundApply linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      {{ $t('B020', '申请退票') }}
    </ld-header>
    <!--  -->
    <div class="tkRefundApplywrapper">
      <mescroll-vue
        :down="down"
      >
        <div class="content">
          <!--航段展示-->
          <div
            class="m-b-5"
            v-for="(info,index3) in tkOrderRangeBeanList"
            :key="index3"
          >
            <voyage
              :show-check="true"
              :flights="[info]"
              @selected="voyageChange.call(this, index3)"
              :index="index3"
            >
              <template
                v-if="info.changeMap"
                #tag
              >
                <van-tag
                  size="medium"
                  color="#8b8ba6"
                >
                  <span>原行程</span>
                </van-tag>
                &nbsp;
              </template>
              <template
                #bottom
                v-if="info.changeMap"
              >
                <new-voyage
                  :flight="changeData(info.changeMap)"
                  :show-car="true"
                >
                  <template #tag>
                    <van-tag
                      class="bg-main white"
                      size="medium"
                    >
                      <span>新行程</span>
                    </van-tag>
                    &nbsp;
                  </template>
                  <template #bottom>
                    <van-row
                      class="noExitTip m-b-5 orange bg-lightColor"
                      gutter="8"
                    >
                      <van-col span="1">
                        <van-icon name="warning" />
                      </van-col>
                      <van-col span="21">
                        原行程发生过改签，按新行程进行退票！
                      </van-col>
                    </van-row>
                  </template>
                </new-voyage>
              </template>
            </voyage>
          </div>
          <!-- 乘机人 -->
          <van-cell
            class="m-b-5"
            v-for="(passItem,index1) in tkOrderPsgBeanList"
            :key="index1"
          >
            <template slot="title">
              {{ passItem.psgName }}
              <van-tag
                type="warning"
                v-show="passItem.fsEmpId"
              >
                {{ $t('attach', '附') }}
              </van-tag>
            </template>
            <template slot="default">
              <van-checkbox
                v-show="passItem.isShow"
                class="fr"
                v-model="passItem.checked"
                @change="choosePsg(index1)"
              />
            </template>
            <template slot="label">
              <div style="width: 272px;">
                {{ passItem.idType|cardType }}：{{ passItem.idNo }}
              </div>
              <div>{{ $t('F008', '手机号') }}：{{ passItem.phoneNumber }}</div>
              <div v-if="passItem.oneTkno">
                {{ $t('F622', '一程票号') }}：{{ passItem.oneTkno }}
              </div>
              <div v-if="passItem.twoTkno ">
                {{ $t('F623', '二程票号') }}：{{ passItem.twoTkno }}
              </div>
              <div v-if="passItem.tkno">
                票号：{{ passItem.tkno }}
              </div>
            </template>
          </van-cell>

          <!-- 自愿退票原因 -->
          <div v-show="!isShowNoRefundReason">
            <van-cell title="自愿退票原因" />
            <van-field
              class="m-b-5"
              is-link
              readonly
              v-model="refundResaon"
              placeholder="请选择自愿退票原因"
              @click="chooseReason('11601037','请选择自愿退票原因')"
            />
          </div>

          <!--非自愿退票原因-->
          <div v-show="isShowNoRefundReason">
            <van-cell title="非自愿退票原因">
              <template slot="default">
                <span
                  class="font12 main-color"
                  @click="cancleNoExit"
                >
                  取消
                </span>
              </template>
            </van-cell>
            <!--              v-show="showFei"-->
            <van-field
              is-link
              readonly
              v-model="refundResaon"
              placeholder="请选择非自愿退票原因"
              @click="chooseReason('11601039','请选择非自愿退票原因')"
              class="m-b-5"
            />
            <van-cell-group>
              <van-cell title="上传附件" />
              <van-notice-bar mode="closeable">
                图片单张不超过5MB，最多支持9张！
              </van-notice-bar>
              <van-cell>
                <van-uploader
                  v-model="fileList"
                  multiple
                  :max-count="9"
                  :before-read="beforeRead"
                  :after-read="afterRead"
                />
              </van-cell>
            </van-cell-group>
          </div>
          <ld-uploader
            class="mt5 round-sm overflow"
            v-if="orderId"
            :order-id="orderId"
            :glywlx="'11002'"
            :cjlx="2"
          />

          <van-row
            class="noExitTip m-b-5 orange bg-lightColor"
            v-show="!isShowNoRefundReason"
            gutter="8"
          >
            <van-col span="1">
              <van-icon name="warning" />
            </van-col>
            <van-col span="21">
              <div>
                由于航班取消、提前、延误、航程改变或其他突发状况，造成您不能正常乘机，您可申请
              </div>
              <div
                class="text-left"
                style="padding-top:10px;"
              >
                <span
                  class="main-color font14 font-bold"
                  @click="changeFei"
                >
                  <ld-button
                    main3
                    size="sm"
                    style="width:100px"
                  >非自愿退票</ld-button>
                </span>
              </div>
            </van-col>
          </van-row>
        </div>
      </mescroll-vue>
    </div>

    <!--提交申请-->
    <ld-tabbar class="bg-white">
      <van-row
        type="flex"
        align="center"
        gutter="8"
        class="full-width pad-lr-5"
      >
        <van-col span="12">
          退票费：
          <span class="font12 money-color">&yen;</span>
          <span class="font22 money-color">{{ total }}</span> 起
        </van-col>
        <van-col span="12">
          <ld-button
            main
            size="md"
            @click="toSubmitApply"
          >
            提交申请
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
    <!--  -->
    <ld-check-list
      ref="cancelReason"
      type="5"
      :title="title"
      :params="parNo"
      @selected="cancelReason"
    />

    <!-- 退票再次提醒弹窗 -->
    <Refunddialog
      :popshow="popshow"
      :refundResaon="refundResaon"
      :isShowNoRefundReason="isShowNoRefundReason"
      :total="total"
      @continueSubmit="continueSubmit()"
      @cancel="popshow=false"
    />
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
// import { Cell , Field ,Checkbox ,Tag} from 'vant'
import {
  Cell,
  CellGroup,
  Field,
  Checkbox,
  Tag,
  Popup,
  Collapse,
  CollapseItem,
  Icon,
  NoticeBar,
  Uploader,
  Toast,
  Button,
  Form,
  Dialog
} from 'vant'
// import voyage from 'Components/tk/voyage/index.vue'
import voyage from 'Views/Tk/tkQuery/dc/voyage/index.vue'
import newVoyage from 'Components/tk/voyage/voyage.vue'
import ldCheckList from 'Components/ldCheckList'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldUploader from 'Components/ldUploader'
import axios from 'axios'
import {localget} from 'Utils/storage.js'
import {API_DEFAULT_CONFIG} from 'Config'
import trQuery from '@/business/service/api/tr/trQuery'
import  Refunddialog  from 'Views/Tk/components/refund_dialog.vue'


export default {
  name: 'TkRefundApply',
  data() {
    return {
      title: '选择自愿退票原因',
      parNo: '11601037',
      tkOrderPsgBeanList: [],
      tkOrderRangeBeanList: [],
      changeMap: {},
      ids: '',
      // 申请 退票入参
      refundType: 1,
      psgIdList: [],
      rangeIdList: [],
      // 自愿退票原因
      // refundReasonVip: '',
      //  非自愿退票原因
      refundResaon: '',
      isShowReason: false,
      refundResaonNo: '',
      //  订单类型  返回列表的参数
      findType: 1,
      // 是否显示非自愿退票原因
      isShowNoRefundReason: false,
      // 客人自愿退票（非自愿退票原因的第一条）
      middleReason: '',
      orderFrom: '',
      // showFei:false,
      total: 0,
      down: {use: false},

      // 上传附件
      fileList: [],
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      file: {},
      popshow:false,//是否显示弹窗
    }
  },
  components: {
    ldButton,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Form.name]: Form,
    [Dialog.name]: Dialog,
    voyage,
    ldCheckList,
    ldTabbar,
    MescrollVue,
    newVoyage,
    ldUploader,
    Refunddialog

  },
  // 计算属性   处理数据时，使用
  computed: {
    orderId() {
      return this.$route.query.orderId
    }
  },
  //页面创建时，去调用方法
  created() {
    this.getRefundOrder()
    this.getBclass()
  },
  activated() {
    this.getRefundOrder()
    this.getBclass()
  },
  methods: {
    //获取 可改签的航段 和 乘机人
    getRefundOrder() {
      this.$api['tkOrder/applyRefund']({
        orderId: this.orderId
      }).then((resp) => {
        let cache = resp.data || {}
        //只有一个人默认行程+乘客勾选
        if (cache.tkOrderPsgBeanList.length == 1) {
          cache.tkOrderPsgBeanList[0].isShow = true
          cache.tkOrderPsgBeanList[0].checked = true
        }
        let checkArr = []
        cache.tkOrderPsgBeanList.forEach(item => {
          checkArr = checkArr.concat(item.refundRangeIdList)
        })
        cache.tkOrderRangeBeanList.forEach(v => {
          let judgeHas = checkArr.some(i => {
            return i == v.rangeId
          })
          if (judgeHas) {
            v.checkShow = true
          } else {
            v.checkShow = false
            v.isShow = true
            v.checked = false
          }
        })
        if (cache.tkOrderPsgBeanList.length == 1) {//只有一个人的处理
          cache.tkOrderRangeBeanList.map((item) => {
            if (item.checkShow == true) {
              item.checked = true
              this.rangeIdList.push(item.rangeId)
            }
          })
          this.matchNowFlightRule()
        }
        this.tkOrderPsgBeanList = cache.tkOrderPsgBeanList || []
        this.tkOrderRangeBeanList = cache.tkOrderRangeBeanList || []
        this.changeMap = cache.changeMap || {}
      })
    },
    //获取第一条原因   客人自愿退票
    getBclass() {
      // this.$api['common/getBClass']({parNo: 130}).then(res => {
      this.$api['common/getBClass']({parNo: 11601039}).then(res => {
        var reasonList = res.data.list
        reasonList.forEach((item) => {
          if (item.id == 13001) {
            this.middleReason = item.cName
          }
        })
      })
    },

    //选择行程选择可退票航段    复选模式
    voyageChange(index) {
      this.rangeIdList = []
      this.tkOrderRangeBeanList.forEach(item => {
        if (item.checked) {
          this.rangeIdList.push(item.rangeId)
        }
      })
      this.chooseOneRangeAndShowPass(this.rangeIdList)
    },
    //当某一航段 被选中时，自动匹配可退票乘机人 ，供客户勾选
    chooseOneRangeAndShowPass(rangeId, boolean) {
      // tkOrderPsgBeanList 为所有的乘客
      this.tkOrderPsgBeanList.forEach(item => {
        // 每个人身上的可退航段id的数组 refundRangeIdList
        var rangeArr = item.refundRangeIdList || []
        let judgeArr = [...new Set(rangeArr)].filter(item => new Set(rangeId).has(item))
        if (judgeArr.length) {
          item.isShow = true
        } else {
          item.isShow = false
        }
      })
      let arr = this.tkOrderPsgBeanList
      this.tkOrderPsgBeanList = []
      this.tkOrderPsgBeanList = arr
    },
    //选择非自愿退票原因
    chooseReason(parNo, title) {
      this.parNo = parNo
      this.title = title
      if (parNo === '11601039') {
        this.refundType = 2
      }
      this.$refs.cancelReason.toggle({params: parNo, title: title})
    },
    //取消原因
    cancelReason(info) {
      // if(this.parNo==11601037){
      // 	this.refundReasonVip=info.cName
      // }else{
      this.refundResaon = info.cName
      // }
    },
    // 选择可退票乘机人
    choosePsg(index) {
      let val = this.tkOrderPsgBeanList[index]
      if (val.checked) {
        if (this.psgIdList.indexOf(val.psgId) == -1) {
          this.psgIdList.push(val.psgId)
        }
      } else {
        for (var i = 0; i < this.psgIdList.length; i++) {
          if (this.psgIdList[i] == val['psgId']) {
            this.psgIdList.splice(i, 1)
          }
        }
      }
      var self = this

      if (this.psgIdList && this.psgIdList.length) {
        this.tkOrderRangeBeanList.forEach(item => {
          if (item.checked) {
            self.psgIdList.forEach(el => {
              if (self.changeMap[el + item.rangeId]) {
                item.changeMap = self.changeMap[el + item.rangeId]
              }
            })
          } else {
            item.changeMap = ''
          }
        })
        let arr = this.tkOrderPsgBeanList
        this.tkOrderPsgBeanList = []
        this.tkOrderPsgBeanList = arr
      }
    },

    // 提交申请
    toSubmitApply(obj) {
      let rangeIdListString = this.rangeIdList.join(',')
      let psgIdListString = this.tkOrderPsgBeanList.filter(item => {
        return item.checked
      })
      psgIdListString = psgIdListString.map(item => {
        return item.psgId
      }).join(',')
      let fileArr = []
      this.fileList.forEach(o => {
        fileArr.push(o.url)
      })

      if (rangeIdListString === '') {
        this.$toast('请选择退票航段！')
        return false
      } else if (psgIdListString === '') {
        this.$toast('请选择乘机人！')
        return false
      } else if (this.refundResaon === '') {
        this.$toast('请选择退票原因！')
        return false
      } else {
        // if(this.refundResaon != '') {
        // 	this.refundType = 2
        // } else {
        // 	this.refundType = 1
        // 	this.refundResaon = this.middleReason
        // }
        let queryString = {
          'orderId': this.orderId,
          'psgIdList': psgIdListString,
          'rangeIdList': rangeIdListString,
          'refundProveUrl': fileArr.join(','),
          'refundReasonVip': '-',
          'refundResaon': this.refundResaon,
          'refundType': this.refundType,
          'orderFrom': '10506',  // app
        }
        this.popshow = true
        if(obj=='yes'){
          this.$api['tkOrder/refundAdd'](queryString).then((resp) => {
            let cache = resp.data || {}
            let arr = cache.refundIdList || []
            if (arr.length > 1) {
              this.$dialog({
                confirmButtonText: '前往',
                message: '系统生成' + (this.rangeIdList.length * this.psgIdList.length) + '个订单前往订单列表查看',
              }).then(() => {
                this.$router.push({
                  path: '/allOrder?findType=4',
                  query: {findType: 4}
                })
              })
            } else if (arr.length == 1) {
              this.$router.push({path: '/tk/tkRefundCmplc', query: {orderId: arr[0]}})
            } else {
              this.$toast('申请失败')
            }
          })
        }
      }
    },
    //继续提交
    continueSubmit() {
      let obj = 'yes'
      this.popshow = false
      this.toSubmitApply(obj)
    },
    changeFei() {
      this.isShowNoRefundReason = true
      // this.showFei=true
      this.refundResaon = ''
    },
    //取消非自愿退票
    cancleNoExit() {
      this.isShowNoRefundReason = false
      // this.showFei=false
      this.refundResaon = ''
    },
    matchNowFlightRule() {
      var psgBeanList = []
      if (this.tkOrderPsgBeanList.length) {
        this.tkOrderPsgBeanList.forEach(item => {
          if (item.checked) {
            psgBeanList.push({
              psgId: item.psgId,
              rangeIds: this.rangeIdList.join(',')
            })
          }
        })
      }
      if (psgBeanList.length) {
        this.$api['tkOrder/matchNowFlightRule']({
          'orderId': this.orderId,
          'psgBeanList': psgBeanList,
          // [
          // 	{
          // 		'psgId': '',
          // 		'rangeBeanList': [
          // 			{
          // 				'rangeId': ''
          // 			}
          // 		]
          // 	}
          // ],
          'operFlag': 1//1 退票 2改签
        }).then(res => {
          var cache = res.data || []
          this.total = 0
          cache.forEach(item => {
            if (item.ruleBeanList) {
              item.ruleBeanList.forEach(el => {
                this.total += Number(el.result)
              })
            }
          })
        })
      }
    },
    changeData(item) {
      // 	newChange:false,
      // 	airlineName:item.airlineName,
      // 	departDate:item.oDepartDate,
      // 	departWeek:item.oDepartWeek,
      // 	departTime:item.oDepartTime,
      // 	arriveDate:item.oArriveDate,
      // 	arriveWeek:item.oArriveWeek,
      // 	arriveTime:item.oArriveTime,
      // 	departAirportName:item.oDepartAirportName,
      // 	arriveAirportName:item.oArriveAirportName,
      // 	departTerminal:item.oDepartTerminal,
      // 	arriveTerminal:item.oArriveTerminal,
      // 	departCityName:item.oDepartCityName,
      // 	arriveCityName:item.oArriveCityName,
      // 	flightNo:item.oFlightNo,
      // 	model:item.oModel,
      // 	cabinName:item.oCabinName,
      // 	cabin:item.oCabin,
      // 	stopFlag:item.oStopFlag,
      // 	stopCity:item.oStopCity,
      // 	stopCityName:item.oStopCityName,
      // 	stopAirport:item.oStopAirport,
      // 	stopAirportName:item.oStopAirportName,
      // 	stopArriveTime:item.oStopArriveTime,
      // 	stopDepartTime:item.oStopDepartTime,
      // },
      return {
        newChange: true,
        airlineName: item.newAirlineName,
        arriveWeek: item.narriveWeek,
        flightNo: item.newFlightNo,
        model: item.nModel,
        cabinName: item.nCabinName,
        cabin: item.nCabin,
        departAirportName: item.newDepartAirportName,
        arriveAirportName: item.newArriveAirportName,
        departCityName: item.newDepartCityName,
        arriveCityName: item.newArriveCityName,
        departDate: item.newDepartDate,
        departTime: item.newDepartTime,
        departWeek: item.newWeek,
        arriveDate: item.newArriveDate,
        arriveTime: item.newArriveTime,
        departTerminal: item.nDepartTerminal,
        arriveTerminal: item.nArriveTerminal,
        flyTime: item.nFlyTime,
        refundRule: item.nRefundRule,
        changeRule: item.nChangeRule,
        upgradeRule: item.nUpgradeRule,
        stopFlag: item.nStopFlag,
        stopCity: item.nStopCity,
        stopCityName: item.nStopCityName,
        stopAirport: item.nStopAirport,
        stopAirportName: item.nStopAirportName,
        stopArriveTime: item.nStopArriveTime,
        stopDepartTime: item.nStopDepartTime,
        shareFlightNo: item.nShareFlightNo,
      }
    },

    // 返回布尔值
    beforeRead(file) {
      if (file instanceof Array) {
        // 判断是否是数组
        file.forEach((v) => {
          this.checkFile(v)
        })
      } else {
        this.checkFile(file)
      }
      return true
    },
    // 图片类型检查
    checkFile(file) {
      const format = ['jpg', 'png', 'jpeg']
      const index = file.name.lastIndexOf('.')
      const finalName = file.name.substr(index + 1)
      if (!format.includes(finalName.toLowerCase())) {
        Toast('请上传' + format.join(',') + '格式图片')
        return false
      }
    },
    afterRead(file) {
      if (file instanceof Array) {
        file.map((v) => {
          v.status = 'uploading'
          v.message = '上传中...'
          this.uploadImg(v)
        })
      } else {
        file.status = 'uploading'
        file.message = '上传中...'
        this.uploadImg(file)
      }
    },
    // 上传
    uploadImg(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('token', localget('access_token'))
      formData.append('sysCode', 7000)
      formData.append('timeout', -1)
      let uploadUrl = API_DEFAULT_CONFIG.URL.uploadFileUrl
      // let uploadUrl = 'http://oss.tmc.tianxiafen.com/ser/parentSystemDfs/1.0.0/file/web/upload';
      axios.post(uploadUrl, formData, {
        headers: this.headers,
      }).then((res) => {
        if (res.data && res.data.data) {
          file.status = 'success'
          file.message = ''
          file.url = res.data.data
        }
      }).catch((err) => {
        this.$notify({
          type: 'warning',
          message: '上传失败',
        })
      })
    },
    //删除
    delUploadImg(item) {
      this.fileList = this.fileList.filter((v) => v.url != item.url)
    }
  },
  watch: {
    'rangeIdList.length'(val) {
      if (val) {
        this.matchNowFlightRule()
      }
    },
    'psgIdList.length'(val) {
      if (val) {
        this.matchNowFlightRule()
      }
    }
  }
}

</script>

<style lang="less" scoped>
.content {
  padding: 0 8px;
}

.m-b-5 {
  margin-bottom: 5px;
}

.pad-lr-5 {
  padding-left: 5px;
  padding-right: 5px;
}

.noExitTip {
  padding: 4px 8px;
  font-size: 10px;
}

.tkRefundApplywrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
}

</style>
